import {BlockType} from '../../../constants/BlockType';
import {BuiltInControlTypes} from '../../../constants/BuiltInControlTypes';
import {ContainerBuiltInControl} from '../ContainerBuiltInControl';

export abstract class ContainerVisibilityBuiltInControl extends ContainerBuiltInControl {
  public getParentControlId(): string {
    return BuiltInControlTypes[BlockType.CONTAINER].HIDDEN_NODE;
  }
}
